import './App.less';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import ProjectLayout from './layout/project';
import { PROJECT_CATEGORY } from './declare/enums/project-category';
import { createContext, useState } from 'react';
import { useEffect } from 'react';
import localStore, { USER_ID, USER_NAME, USER_UUID } from './store/local-store';
import { userCheckLogin } from './declare/api/user';
import { User } from './declare/interface/user';
import ReconnectingWebSocket from 'reconnecting-websocket';
import { SystemStatus, useSystemService } from './store/system-store';
import UserFeedBackPanel from './components/user-feedback';
import { useFeedbackUploadService, UserFeedbackUploadFileState } from './components/user-feedback/upload-panel';
import { UserWorkStatus } from './declare/enums/user-work-status';
import { getRsUserAuths } from './declare/api/permission';
import { UserAuthStatus, useUserAuthService } from './store/auth-store';
import DownloadPanel, { DownloadState, useDownloadService } from './panel/download-panel';

export const WsConfig = {
    // TODO: build 部署时要修改ws地址端口
    address: process.env.NODE_ENV === 'development' ?
        `ws://localhost` :
        `wss://tools.tncet.com`,
    port: process.env.NODE_ENV === 'development' ? ':9557' : '',

}

export const SystemContext = createContext<SystemStatus>(null);
export const DownloadContext = createContext<DownloadState>(null);
export const UserFeedbackUploadFileContext = createContext<UserFeedbackUploadFileState>(null);
export const UserAuthContext = createContext<UserAuthStatus>(null);

function App() {

    const navigate = useNavigate();
    const location = useLocation(); // 获取当前路由的路径
    const systemContext = useSystemService();
    const userAuthContext = useUserAuthService();
    const [visible, setVisible] = useState(false);  // 意见反馈弹窗

    let timer$;

    /**
     * 定期校验登录
     */
    useEffect(() => {
        const searchValue = location.search;
        if (!!searchValue) {
            // 使用 URLSearchParams 解析查询参数
            const queryParams = new URLSearchParams(location.search);

            // 获取参数 'a' 的值，如果没有则返回 null
            const token = queryParams.get('token');
            if (token != null && token != "null") {
                localStore.token = token;
            }
        }
        checkLogin();
        timer$ = setInterval(() => {
            checkLogin();
        }, 60000)
        return (() => {
            clearInterval(timer$);
        })
    }, [systemContext.rws])


    const goBackToErp = () => {
        let goBackUrl = process.env.NODE_ENV === 'development' ? "http://localhost:3000" : "http://teamerp.tncet.com";
        window.location.href = goBackUrl;
    }

    /**
     * 校验登录
     * @returns 
     */
    const checkLogin = () => {
        let token = localStore.token || '';
        if (token.length <= 0) {
            if (!location.pathname.includes('login') && !location.pathname.includes('recruit') && !location.pathname.includes('forget')) {
                localStore.clear();
                goBackToErp();
            }
            return;
        }
        userCheckLogin()
            .then(res => {
                let userDetail: User = res.data;
                localStore.set(USER_ID, userDetail.id);
                localStore.set(USER_UUID, userDetail.uuid);
                localStore.set(USER_NAME, userDetail.name);

                getRsUserAuths(localStore.userId).then(res => {
                    userAuthContext.onUserAuthsChange(res.data || []);
                })

                if (userDetail.userProject) {
                    localStore.userProjectId = userDetail.userProject.id;
                }
                if (systemContext.rws == null) {
                    initWs();
                }
                if (userDetail.workStatus === UserWorkStatus.APPLIED && !location.pathname.includes('recruit')) {
                    navigate('/recruit');
                    return;
                }
            }).catch(err => {
                if (!location.pathname.includes('recruit') && !location.pathname.includes('forget')) {
                    localStore.clear();
                    goBackToErp()
                }
            })
    }


    const initWs = () => {
        setTimeout(() => {
            const userUuid = localStore.userUuid;
            if (userUuid == null) return;
            let rws = new ReconnectingWebSocket(`${WsConfig.address}${WsConfig.port}/api-teamerp/ws?uuid=${userUuid}&device=WEB`);
            systemContext.resetRws(rws);
        }, 0)
    }



    return (
        <SystemContext.Provider value={systemContext}>
            <DownloadContext.Provider value={useDownloadService()}>
                <UserAuthContext.Provider value={userAuthContext}>
                    <UserFeedbackUploadFileContext.Provider value={useFeedbackUploadService()}>
                        <div className="tn-base">
                            <Routes>
                                <Route path='/own/*' element={<ProjectLayout type={PROJECT_CATEGORY.PERSONAL} feedbackVisible={visible} changeFeedbackVisible={(value) => setVisible(value)} />} />
                                <Route path='/projects/:projectId/*' element={<ProjectLayout type={PROJECT_CATEGORY.PROJECT} feedbackVisible={visible} changeFeedbackVisible={(value) => setVisible(value)} />} />
                                <Route path='/institutions/:institutionId/*' element={<ProjectLayout type={PROJECT_CATEGORY.INSITITUTION} feedbackVisible={visible} changeFeedbackVisible={(value) => setVisible(value)} />} />
                                <Route path='/library/*' element={<ProjectLayout type={PROJECT_CATEGORY.LIBRARY} feedbackVisible={visible} changeFeedbackVisible={(value) => setVisible(value)} />} />
                                <Route path="*" element={<Navigate to={`/own`} />} />
                            </Routes>
                        </div>
                        <DownloadPanel />
                        <UserFeedBackPanel visible={visible} changeVisible={(value) => setVisible(value)} />
                    </UserFeedbackUploadFileContext.Provider >
                </UserAuthContext.Provider >
            </DownloadContext.Provider>
        </SystemContext.Provider>


    );
}

export default App;
